import { render } from "./loader-small.vue?vue&type=template&id=24c33f6c&scoped=true"
import script from "./loader-small.vue?vue&type=script&lang=js"
export * from "./loader-small.vue?vue&type=script&lang=js"

import "./loader-small.vue?vue&type=style&index=0&id=24c33f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c33f6c"]])

export default __exports__